import { __require as requireGlobalThis } from './node_modules-core-js-internals-global-this.js';
import { __require as requireIsCallable } from './node_modules-core-js-internals-is-callable.js';

var weakMapBasicDetection;
var hasRequiredWeakMapBasicDetection;

function requireWeakMapBasicDetection () {
	if (hasRequiredWeakMapBasicDetection) return weakMapBasicDetection;
	hasRequiredWeakMapBasicDetection = 1;
	var globalThis = requireGlobalThis();
	var isCallable = requireIsCallable();

	var WeakMap = globalThis.WeakMap;

	weakMapBasicDetection = isCallable(WeakMap) && /native code/.test(String(WeakMap));
	return weakMapBasicDetection;
}

export { requireWeakMapBasicDetection as __require };
//# sourceMappingURL=node_modules-core-js-internals-weak-map-basic-detection.js.map
